function Sidebar({cats,state,setState,onSubmit}) {
    return (
        <ul className="list-group list-group-flush rounded">
            <form onSubmit={onSubmit}>
            <li className="list-group-item d-none d-lg-block">
                <h5 className="mt-1 mb-2">دسته بندی</h5>
                <div className="d-flex flex-wrap my-2">
                {cats.map((v,i) => {
                    return (
                        <button type="button" key={i} onClick={() => setState((prev) => ({ ...prev, cat: +v.id }))} className="btn btn-sm btn-outline-dark rounded-pill me-2 mb-2">
                            {v.name}
                        </button>
                    );
                })}
                </div>
            </li>
            {/* <li className="list-group-item">
                <h5 className="mt-1 mb-1">برند</h5>
                <div className="d-flex flex-column">
                {brands.map((v, i) => {
                    return (
                    <div key={i} className="form-check">
                        <input className="form-check-input" type="checkbox" />
                        <label className="form-check-label" htmlFor="flexCheckDefault">
                        {v}
                        </label>
                    </div>
                    );
                })}
                </div>
            </li> */}
            {/* <li className="list-group-item">
                <h5 className="mt-1 mb-1">سازنده</h5>
                <div className="d-flex flex-column">
                {manufacturers.map((v, i) => {
                    return (
                    <div key={i} className="form-check">
                        <input className="form-check-input" type="checkbox" />
                        <label className="form-check-label" htmlFor="flexCheckDefault">
                        {v}
                        </label>
                    </div>
                    );
                })}
                </div>
            </li> */}
            <li className="list-group-item">
                <div className="d-flex flex-column">
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" checked={state.quant} id="mojod" onChange={(e) => setState((prev) => ({ ...prev, quant: e.target.checked }))}/>
                        <label className="form-check-label" htmlFor="mojod">
                            نمایش موجود
                        </label>
                    </div>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" id="rakhfif" checked={state.sale} onChange={(e) => setState((prev) => ({ ...prev, sale: e.target.checked }))}/>
                        <label className="form-check-label" htmlFor="rakhfif">
                            نمایش تخفیف دار
                        </label>
                    </div>
                </div>
            </li>
            <li className="list-group-item">
                {/* <h5 className="mt-1 mb-2">بازه قیمت</h5> */}
                <div className="d-grid d-block mb-3">
                    {/* <div className="form-floating mb-2">
                        <input
                        type="text"
                        className="form-control"
                        placeholder="Min"
                        defaultValue="۱۰۰۰۰"
                        />
                        <label htmlFor="floatingInput">حداقل قیمت</label>
                    </div>
                    <div className="form-floating mb-2">
                        <input
                        type="text"
                        className="form-control"
                        placeholder="Max"
                        defaultValue="۵۰۰۰۰"
                        />
                        <label htmlFor="floatingInput">حداکثر قیمت</label>
                    </div> */}
                    <button type="submit" className="btn btn-outline-dark mt-2">اعمال فیلتر</button>

                </div>

            </li>

            </form>
        </ul>
    );
}

export default Sidebar;